import httpLiveChat from './httpLiveChat'

export default {
  async createChat(live_id) {
    
      const response = await httpLiveChat.post('/api/create-chat', { live_id })
      return response.data
  
  },

  async registerUserOnChat(user_name, live_id) {
    const user_agent = navigator.userAgent
   
      const response = await httpLiveChat.post('/api/register-user', { user_name, live_id, user_agent })
      return response.data
    
  },

  async terminateChat(live_id) {
   
      const response = await httpLiveChat.post('/api/terminate-chat', { live_id })
      return response.data
    
  },

  async changeChatStatus(chat_id, status) {
    
      const response = await httpLiveChat.put('/api/update-chat-status', { chat_id, status })
      return response.data
    
  },

  async removeUserFromChat(chat_id, user_id) {
    
      const response = await httpLiveChat.post('/api/remove-user', { chat_id, user_id })
      return response.data
    
  },

  async removeMessageFromChat(chat_id, message_id) {
    
      const response = await httpLiveChat.post('/api/remove-message', { chat_id, message_id })
      return response.data
    
  },

  async getChatMessages(chat_id, limit, skip, sort_by, sort_order) {
   
      const response = await httpLiveChat.get('api/chat-messages', { params: { chat_id, limit, skip, sort_by, sort_order } })
      return response.data
    
  },

  async getChatUsers(chat_id, limit, skip, sort_by, sort_order) {
    
      const response = await httpLiveChat.get('api/chat-users', { params: { chat_id, limit, skip, sort_by, sort_order } })
      return response.data
    
  },
  


}
